export default __webpack_public_path__ + "618a02ec341526208c1ce462d6e4e941.svg";